<template>
  <div id="mySearchProject">
    <van-popup v-model="show" position="top" :style="{ height: '70vh' }">
      <div class="pop4">
        <div class="projectRightTitle" @click="show=false">
          选择地区
          <img class="pic1" :src="getImage('pop/up')" alt="">
        </div>
        <div>
        </div>
        <div class="content">
          <van-tree-select
              height="100%"
              :items="areas"
              @click-item="hiddenTs"
              :active-id.sync="activeId"
              :main-active-index.sync="activeIndex"
              @click-nav="changeArea(activeIndex)"
          >
            <div class="rightTitle">
              <span class="titleSpan">全部</span>
            </div>
          </van-tree-select>
        </div>
      </div>
    </van-popup>
    <van-search
        v-model="value"
        :left-icon="require('./../assets/img/search/search.png')"
        placeholder="请输入搜索关键词"
        @search="onSearch"
        :clearable="false"/>
    <div class="searchTabbar">
      <div class="content1">
        <van-tabbar v-model="active" @change="onChange">
          <!--1 badge="3"-->
          <van-tabbar-item icon="home-o">
            <span>公益项目</span>
            <template #icon="props">
              <img :src="props.active ? icon.active : icon.inactive"/>
            </template>
          </van-tabbar-item>
          <!--2-->
          <van-tabbar-item icon="project-o">
            <span>专家义诊</span>
            <template #icon="props">
              <img :src="props.active ? icon.active2 : icon.inactive2"/>
            </template>
          </van-tabbar-item>
          <!--3-->
          <van-tabbar-item icon="setting-o">
            <span>援助服务站</span>
            <template #icon="props">
              <img :src="props.active ? icon.active3 : icon.inactive3"/>
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
      <div class="swiper-container mySwiper4">
        <div class="swiper-wrapper">
          <!--1-->
          <div class="swiper-slide mySlide4">
            <div class="expert" v-if="!configs.length>0">
              <img class="expertPic" :src="getImage('search/tip')" alt="">
              <div class="expertText">
                正在建设中...
              </div>
            </div>
            <div class="welfare" v-if="configs.length>0">
              <div class="projectListBox" :class="projectListBoxShow">
                <div class="projectList" v-for="(project,index) in configs" :key="index" @click="localhrefUrl(project)">
                <!--<wx-open-launch-weapp v-if="project.personage_project_id && project.is_real_auth=='Y'" id="launch-btn" class="right-btn" username="gh_8d61f0c3b29e" :path="project.raise_medicine_url"
                @error="handleErrorFn" @launch="handleLaunchFn">
                      <script type="text/wxtag-template">
                          <style>.wx-btn { width: 100%;height: 100%;display: block;position: absolute;left: 0;top: 0;z-index: 9;opacity: 0!important; }</style>
                          <div class="wx-btn"></div>
                      </script>
              </wx-open-launch-weapp>-->

                  
                  <div class="projectBg">
                    <div class="projectPic">
                      <img :src="baseImgUrl + project.image_url" alt="" class="projectPic">
                    </div>
                    <div class="projectRight">
                      <div class="title">{{ project.title }}</div>
                      <div class="content3">
                        {{ common.delHtmlTag(project.content) }}
                      </div>
                      <p class="state" v-html="getEndDate(project.end_date)"></p>
                    </div>
                  </div>
                  <div class="line">
                  </div>
                </div>
              </div>
              <div class="more" @click="showWelfare()" v-if="moreCro">
                <div class="moreText">
                  <span class="text">更多</span>
                  <img class="morePic" :src="getImage('aboutUs/down')" alt="">
                </div>
              </div>
            </div>
            <div class="box1"></div>
          </div>
          <!--2-->
          <div class="swiper-slide mySlide4">
            <div class="expert">
              <img class="expertPic" :src="getImage('search/tip')" alt="">
              <div class="expertText">
                正在建设中...
              </div>
            </div>
            <div>
            </div>
          </div>
          <!--3-->
          <div class="swiper-slide mySlide4 mySlide4-3">
            <div class="content3Bg">
              <van-list
                  v-model="loading"
                  :finished="finished"
                  loading-text="加载更多..."
                  @load="commentLoad"
                  class="van3List"
              >
                <div class="assistance">
                  <p class="title3-1">《患者援助服务站就医地图》</p>
                  <div id="mapChart" class="map"></div>
                </div>
                <div class="choice">
                  <div class="title3-2" @click="buttonDown()">
                    <span class="title3-2-1">选择地区</span>
                    <img class="buttonDown" :src="getImage('search/down')" alt="">
                  </div>
                  <div class="expert3" v-if="!services.length>0">
                    <img class="expertPic" :src="getImage('search/tip')" alt="">
                    <div class="expertText">
                      正在建设中...
                    </div>
                  </div>
                  <div>
                  </div>
                  <div class="choiceListBg" v-if="services.length>0">
                    <div class="choiceList" v-for="(item,index) in services" :key="index">
                      <!--<div class="choiceList" v-for="(item,index) in services" :key="index">-->
                      <div class="choiceBg">
                        <img class="choicePic" :src="baseImgUrl + item.image_url" alt="">
                        <div class="choiceRight">
                          <div class="title3-2-2">
                            <span class="title3-2-2-1">{{ item.title }}</span>
                          </div>
                          <div class="phoneBox font3">
                            <span class="font3">电话：</span>
                            {{ item.tel }}
                          </div>
                          <div class="choiceRightText2">
                            <span class="font3">地址：</span>
                            <div class="content3-1 font3">
                              {{ item.address }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="choiceLine">
                      </div>
                    </div>
                  </div>
                </div>
              </van-list>
              <div class="box2"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination myPagination4"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import SwiperCore, { Pagination } from 'swiper/core'; //引入
import 'swiper/swiper-bundle.css';//样式地址与之前有不同
import lmChina from '@/assets/js/china.json'
import wx from "weixin-js-sdk";

SwiperCore.use([Pagination]); // 使用

export default {
  name: "mySearchProject",
  data () {
    return {
      icon: {
        active: this.getImage('search/pic1'),
        inactive: this.getImage('search/pic1-2'),
        active2: this.getImage('search/pic2'),
        inactive2: this.getImage('search/pic2-2'),
        active3: this.getImage('search/pic3'),
        inactive3: this.getImage('search/pic3-2'),
      },
      currentIndex: 0,
      configs: [],
      useChina: [],
      services: [],
      areas: [],
      //下拉列表
      items: [
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
        { text: '', coordinate: '' },
      ],
      activeId: 0,
      activeIndex: 0,
      n: 0,
      show: false,
      projectListBoxShow: '',
      value: '',
      mySwiper4: '',
      active: 0,
      tipShow: true,
      lmWelfare: false,
      moreCro: false,
      size: 5,
      sizeAdd: 10,
      size3: 10,
      size3Add: 10,
      loading: false,//加载状态
      finished: false,//是否加载
      current_city_id:"",
      search_name:""
    }      
  },
  created () {
    this.loadBaseArea();
    this.useChina = lmChina;
    this.init();
    this.loadData();
  },
  methods: {
    init(){
      this.http.req("/wx/config", { url: location.href }, (res) => {
        this.loadConfig(res);
      });
    },
    loadConfig(data) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
         jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "checkJsApi",
            "scanQRCode"
          ], // 必填，需要使用的JS接口列表
          openTagList:['wx-open-launch-weapp']
      });
      wx.error(() => {
        // alert("error");
      })
      wx.ready(() => {
        this.loadData();
      })
    },
     localhrefUrl(item) {

             this.$router.push("/indexContent/gyxm?fid=" + item.fid);


      // this.loadUserInfo(() => {
      //   if (this.user_info.is_real_auth != "Y") {
			// 		this.$emit('showPopPage',true)
      //     return;
      //   }
      //   this.common.hrefUrl(url);
      // });
    },
    loadUserInfo(fn) {
      var userInfo = this.common.getUserInfo();
      if (!userInfo || userInfo == "undefined" || userInfo == "null") {
        return "";
      } else {
        this.user_info = JSON.parse(userInfo);
        if (fn) {
          fn();
        }
      }
    },
    handleErrorFn(e){
      console.log(e);
    },
    handleLaunchFn(e){
      console.log(e);
    },
    loadBaseArea () {
      this.http.req("/c_o_AssistanceServices/findBaseArea", {}, (res) => {
        this.areas = res;
      });
    },
    loadData () {
      if (this.currentIndex == 0) {
        this.loadConfigs();
      } else if (this.currentIndex == 2) {
        this.loadServices();
      }
    },
    loadServices () {
      this.http.req("/c_o_AssistanceServices/findPaginate", { size: this.size3,current_city_id:this.current_city_id }, (res) => {
        this.services = res.list;
        if (this.services.length >= res.rows) {
          setTimeout(() => {
            this.finished = true
          }, 800)
        } else {
          setTimeout(() => {
            this.finished = false
            this.loading = false;
          }, 800)
        }
      });
      this.size3 += this.size3Add
    },
    commentLoad () {
      this.loadServices()
    },
    loadConfigs () {
      this.http.req("/c_o_PublicWelfareConfig/findPaginate", { size: this.size }, (res) => {
        this.configs = res.list;
        if (this.configs.length >= 4) {
          this.moreCro = true
          if (res.rows <= res.list.length) {
            this.moreCro = false
          }
        } else {
          this.moreCro = false
        }
        // for (var i = 0; i <= this.configs.length; i++) {
        //   if (this.configs[i].status_name == '上架') {
        //     this.configs[i].status_name = '开展中'
        //   }
        // }
      });
    },
    showWelfare () {
      this.size += this.sizeAdd
      this.loadConfigs()
    },
    mapFn () {
      this.mapChart = this.$echarts.init(document.getElementById('mapChart'));
      this.mapChart.setOption({
        legend: {
          show: false
        },
        geo: {
          map: "china",
          zoom: 1.2,
          itemStyle: { //地图区域的多边形 图形样式。
            normal: {
              areaColor: '#FFE8E9',
              background: '#F79D9F',
              borderColor: '#F79D9F',
            },
            emphasis: { //高亮状态下的样试
              areaColor: '#FFE8E9',
            },
          },
          label: {
            normal: {
              show: true,
            },
            emphasis: {
              show: false
            }
          },
        },
        series: [
          {
            type: 'scatter',
            showEffectOn: 'render',//配置什么时候显示特效
            coordinateSystem: 'geo',//该系列使用的坐标系
            symbolSize: 55,//标记的大小
            color: '#EF171C',
            symbol: 'pin',
            data: [
              { name: '北京', value: [116.40, 40.40] },
            ],
            zlevel: 99999
          },
        ],
      }),
          window.addEventListener('resize', () => {
            // 自动渲染echarts
            this.mapChart.resize();
          })
    },
    addArea () {
      for (var x = 0; x < this.useChina.features.length; x++) {
        this.items[x].text = this.useChina.features[x].properties.name
        this.items[x].coordinate = this.useChina.features[x].properties.cp
      }
    },
    changeArea (activeIndex) {
      var a = this.areas[activeIndex].text
      for (var y = 0; y < this.items.length; y++) {
        if (a == this.items[y].text) {
          var b = this.items[y].coordinate
        }
      }
      this.mapChart.setOption({
        series: [{
          data: [{ name: a, value: b }]
        }]
      })
    },
    hiddenTs (item) {
      this.show = false;
      this.current_city_id = item.id;
      this.loadData();
    },
    goMySearch () {
      this.$router.push('/mySearchProject/mySearch')
    },
    goSearchSuccess () {
      this.$router.push('/mySearchProject/searchSuccess')
    },
    onChange (index) {
      this.currentIndex = index;
      this.mySwiper4.slideTo(this.active, 500);
      this.loadData();
    },
    getImage (src) {
      return this.$parent.getImage(src);
    },
    buttonDown () {
      this.show = true;
    },

    onSearch (val) {
      this.search_name = val;
      if (!val) {
        this.$router.push('/mySearch')
      } else {
        this.loadSearch();
      }
    },
    loadSearch(){
      this.http.req("/c_o_NewsInfo/loadSearch", { search_name:this.search_name }, (res) => {
        if(res.configs.total==0&&res.services.total==0){
          this.$router.push('/mySearch')
        }else{
          this.$router.push('/searchSuccess?search_name='+this.search_name)
        }
      });
    },
      // 返回公益项目状态
      getEndDate (endDate) {
        if (endDate && endDate > new Date().getTime()) {
            return '开展中'
        }
        return '已结束'
      }
  },
  mounted () {
    let that = this
    this.addArea();
    this.mapFn();
    this.mySwiper4 = new Swiper('.mySwiper4', {
      direction: 'horizontal',
      pagination: {
        el: '.myPagination4',
        type: 'bullets',
        clickable: true
      },
      on: {
        slideChangeTransitionEnd: function () {
          that.active = this.activeIndex
        }
      }
    })
  }
}
</script>
<style scoped>
	.wx-btn{
		opacity: 0!important;;
	}
#mySearchProject {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 750px;
  height: 100vh;

}

.van-search__content {
  width: 686px;
  height: 68px;
  background: #F4F4F5;
  border-radius: 34px;
  margin: 19px 32px;

}

.van-cell {
  width: 254px;
  /*height: 27px;*/
  font-size: 28px;
  font-weight: normal;
  color: #999999;
  margin-top: 10px;
}

.van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
  font-size: 28px;
  margin-top: 6px;
}


.searchTabbar {
  top: -27px;
}

.content1 {
  height: 165px;
  z-index: 8;
  box-shadow: 0px 18px 10px rgba(0, 0, 0, 0.03);
  /*阴影出现在元素下方*/
}

.van-search {
  z-index: 99;
}

.mySlide4 {
  width: 100%;
  background: #FAF3F2;
  overflow-y: scroll;
  height: 86vh;
  z-index: 99;
}

.projectBg {
  background: #FFFFFF;
  width: 686px;
  height: 192px;
  padding-top: 33px;
  margin-left: 30px;
  padding-bottom: 27px;
  padding-right: 32px;
}

.mySwiper4 {
  z-index: 6;

}

.projectPic {
  width: 256px;
  height: 192px;
  border-radius: 8px;
  object-fit: cover;
}

.projectRight {
  width: 407px;
  height: 192px;
  position: absolute;
  top: 0;
  right: 0;
  padding-top: 43px;
  padding-right: 32px;
}

.title {
  font-size: 34px;
  line-height: 34px;
  font-weight: bold;
  color: #222222;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  width: 416px;
}

.content3 {
  font-size: 26px;
  line-height: 30px;
  font-weight: normal;
  color: #555555;
  margin: 24px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  width: 416px;
  word-break: break-all;
  /*height: 67px;*/
}

.state {
  font-size: 26px;
  line-height: 26px;
  font-weight: normal;
  color: #EF171C;
}

.line {
  width: 686px;
  height: 1px;
  background: #EEEEEE;
  position: absolute;
  z-index: 5;
  right: 32px;
}

.expert {
  height: 100vh;
  position: absolute;
  z-index: 99;
  width: 100%;
  overflow: hidden;
}

.expert3 {
  height: 50vh;

}

.expertPic {
  margin-top: 181px;
  left: 50%;
  transform: translateX(-50%);
}

.assistance {
  height: 712px;
  margin-bottom: 20px;
  background: #FFFFFF;
}

.choice {
  background: #FFFFFF;
  /*margin-bottom: 190px;*/
}

.box2 {
  height: 190px;
}

.mySlide4-3 {
  background: #FAF3F2;
}

.title3-1 {
  font-size: 32px;
  font-weight: bold;
  padding-top: 58px;
  margin-bottom: 26px;
  text-align: center;
  color: #555555;
  line-height: 44px;
}

.bm-view {
  width: 656px;
  height: 542px;
}

.map {
  width: 656px;
  height: 542px;
  left: 47px;
  top: -10px;
}


.title3-2 {
  font-size: 32px;
  font-weight: bold;
  color: #222222;
  line-height: 44px;
  margin-left: 31px;
  padding-top: 33px;
  padding-bottom: 32px;
}

.title3-2-1 {
  margin-right: 12px;
}

.choiceBg {
  background: #FFFFFF;
  margin-bottom: 33px;
  width: 686px;
  height: 192px;
  margin-top: 33px;
  margin-left: 32px;
}

.choicePic {
  width: 198px;
  height: 198px;
  object-fit: cover;
  border-radius: 8px;
}

.choiceRight {
  width: 477px;
  height: 51px;
  position: absolute;
  top: 0;
  right: 0;
  margin: 3px 0;
  /*padding-right: 28px;*/
}

.title3-2-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-size: 34px;
  height: 40px;
  margin-bottom: 15px;
  width: 452px;
  text-overflow: ellipsis;
  font-weight: bold;
  color: #222222;
  overflow: hidden;
}

.title3-2-2-1 {
  top: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.font3 {
  font-size: 28px;
  font-weight: normal;
  color: #555555;
  line-height: 42px;
  display: inline;
}

.choiceLine {
  width: 686px;
  height: 1px;
  background: #EEEEEE;
  right: 0;
  margin-left: 32px;
}

.choiceRightText2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}

.myPagination4 {
  top: 0;
}

.phone {
  left: 11px;
}

.choiceListBg {
  overflow-x: hidden;
}

.content3Bg {
  top: 0;
  left: 0;
  z-index: 99;
}

.more {
  height: 91px;
  width: 100%;
  background: #FFFFFF;
}

.welfare {
  background: #FFFFFF;
  margin-bottom: 155px;
}

.moreText {
  font-size: 28px;
  font-weight: normal;
  color: #EF171C;
  line-height: 44px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

}

.expert {
  background: #FFFFFF;
  height: 100%;
}

.projectRightTitle {
  font-size: 32px;
  font-weight: bold;
  color: #222222;
  margin: 33px 31px;

}

.pic2 {
  margin-left: 16px;
}

.content {
  width: 750px;
  height: 70vh;
  background: #FFFFFF;
  overflow-x: hidden;
  /*overflow-y: scroll;*/
}

.contentLeft {
  width: 374px;
  height: 1124px;
  background: #F6F6F6;
  overflow-y: scroll;
}

.provinceBg {
  width: 374px;
  height: 100px;
  /*background: #FFFFFF;*/
}

.contentTitle {
  font-size: 32px;
  font-weight: normal;
  color: #222222;
  top: 35px;
  left: 32px;
}

.contentRight {
  width: 376px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  overflow-y: scroll;
}

.rightText {
  width: 374px;
  height: 100px;
  background: #FFFFFF;

}

.expertText {
  font-size: 30px;
  font-weight: normal;
  color: #888888;
  line-height: 50px;
  text-align: center;
}

.titleText {
  font-size: 32px;
  font-weight: normal;
  color: #222222;
  top: 35px;
  left: 32px;
}

.provinceBg.checked {
  background: #FFFFFF;

}

.projectListBox {
  /*height: 85vh;*/
  /*height: 1008px;*/
  overflow: hidden;
  position: relative;
}

.projectListBoxShow {
  height: 100%;
}

.van-tabbar-item__icon::after {
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 1;
  width: 40px;
  height: 3px;
  background-color: #ee0a24;
  border-radius: 3px;
}

.van-tree-select__nav-item {
  padding: 0;
  height: 100px;
  font-size: 32px;
  /*font-weight: bold;*/
  font-weight: normal;
  color: #222222;
}


.van-sidebar-item--select {
  font-size: 36px;
  font-weight: bold;
  color: #222222;
}

.van-sidebar-item--select::before {
  opacity: 0;
}

.rightTitle {
  height: 100px;

}

.van-tree-select__item {
  height: 67px;
  font-size: 32px;
  font-weight: normal;
  padding: 33px 32px 0 42px;

}

.van-icon-success::before {
  content: '';
}

.box1 {
  height: 60px;
  bottom: 0;
}

.box {
  /*height: 11vh;*/
}

.text {
  margin-right: 6px;
}

.morePic {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}


.phoneBox {
  margin-top: 20px;
  margin-bottom: 9px;
  height: 42px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  /*margin: 0;*/
}

.van-tree-select {
  width: 84vh;
}


    .right-btn, .wx-btn {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
    }
</style>

<style>
  .van-search .van-field__left-icon .van-icon img.van-icon__image{
    width: 28px!important;
    height: 28px!important;
    margin: 0 18px;
  }
</style>